import { type WarehouseOut, refKeys, warehousesApi } from '@/features/references/api'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

export const warehousesListQuery = () =>
  typedSuspenseOptions<readonly WarehouseOut[]>({
    queryKey: refKeys.warehouses(),
    queryFn: ({ signal }) => warehousesApi.list(signal),
    staleTime: 30_000,
  })

export const warehouseQuery = (warehouseId: number) =>
  typedSuspenseOptions<WarehouseOut>({
    queryKey: refKeys.warehouse(warehouseId),
    queryFn: ({ signal }) => warehousesApi.get(warehouseId, signal),
    staleTime: 30_000,
  })
